import { boolean, number, object, string } from 'yup';
import { ManagerDataSharingOption } from '../types/userTypes';
import { KnownAsName, ManagerEmail, ManagerEmailConfirmation, ManagerName, ManagerSharingDataOption, RequestManager, } from '../UserDataManagement';
import { getFormValues } from './validationContextTools';
const MaxNameLength = 75;
const RequiredMessage = 'This field is required';
const NameTooLong = `Name can have up to ${MaxNameLength} characters`;
const CharactersNotAllowed = 'Name can not contain the following characters \\/<>:.#';
const EmailNotValid = 'Value has to be a valid email';
function checkEmailMatch(emailValue, emailConfirmationValue) {
    return emailValue === emailConfirmationValue;
}
export const introManagerFormSchemaFunc = () => object({
    [RequestManager]: boolean(),
    [ManagerEmail]: string()
        .email(EmailNotValid)
        .test('noAliases', 'Email addresses cannot contain an alias', (value) => {
        return !value?.includes('+');
    })
        .when(RequestManager, {
        is: (manager) => manager,
        then: string().required(RequiredMessage),
    }),
    [ManagerEmailConfirmation]: string().test('max', () => 'Please enter a matching email address', (value, context) => {
        const managerEmail = getFormValues(context).managerEmail ?? '';
        const requestManager = getFormValues(context).requestManager ?? false;
        return !requestManager || checkEmailMatch(managerEmail, value);
    }),
    [ManagerName]: string()
        .max(MaxNameLength, NameTooLong)
        .matches(/[^\\/<>:.\t\n\r#]+$/, CharactersNotAllowed)
        .notRequired()
        .when(RequestManager, {
        is: (manager) => manager,
        then: string().required(RequiredMessage),
    }),
    [KnownAsName]: string()
        .max(MaxNameLength, NameTooLong)
        .matches(/[^\\/<>:.\t\n\r#]+$/, CharactersNotAllowed)
        .when(RequestManager, {
        is: (manager) => manager,
        then: string().required(RequiredMessage),
    }),
    [ManagerSharingDataOption]: number().when(RequestManager, {
        is: (manager) => manager,
        then: number()
            .oneOf([
            ManagerDataSharingOption.AllHistoricData,
            ManagerDataSharingOption.CurrentEntitlementYear,
        ], RequiredMessage)
            .required(RequiredMessage),
    }),
});
const introManagerFormSchema = introManagerFormSchemaFunc();
